import React from 'react';
import { withRouter } from 'inferno-router';
import { StyleSheet, Text, Image, View } from './components/base_components';

import UserCurrencyStore from './stores/user_currency_store';
import UserStore from './stores/user_store';
import util from './tools/util';

import WideButton from './components/buttons/wide_button';
import MenuButton from './components/buttons/menu_button';

import CryptoInOverlay from './components/overlays/crypto_in_overlay';
import CryptoOutOverlay from './components/overlays/crypto_out_overlay';

const styles = StyleSheet.create({
  cryptoScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '1.4em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
  balanceWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  balanceLabel: {
    color: 'white',
    fontSize: '1.4em',
  },
  balanceLine: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '3em',
    height: '3em',
  },
  coinText: {
    marginLeft: '0.4em',
    marginTop: '0.6em',
    color: 'white',
    fontSize: '2.5em',
  },
});

const COIN_IMG = require('./assets/img/dank_coin.gif');

type Props = {
  history: any;
};
type State = {
  is_logged_in: boolean;
  dank_coin_balance: number;
  show_tx_in: boolean;
  show_tx_out: boolean;
};

class CryptoScreen extends React.PureComponent<Props, State> {
  state = {
    is_logged_in: UserStore.isLoggedIn(),
    dank_coin_balance: UserCurrencyStore.getBalance('dank_coin') || 0,
    show_tx_in: false,
    show_tx_out: false,
  };
  componentDidMount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
    UserCurrencyStore.fetchCurrency('dank_coin');
    this._onCurrencyUpdate();
  }
  componentWillUnmount() {
    UserCurrencyStore.addChangeListener(this._onCurrencyUpdate);
  }
  _onCurrencyUpdate = () => {
    const dank_coin_balance = UserCurrencyStore.getBalance('dank_coin') || 0;
    this.setState({ dank_coin_balance });
  };

  _onEnsureLogin = () => {};
  _onTransferOutPress = () => this.setState({ show_tx_out: true });
  _onTransferOutDone = () => this.setState({ show_tx_out: false });
  _onTransferInPress = () => this.setState({ show_tx_in: true });
  _onTransferInDone = () => this.setState({ show_tx_in: false });

  _onLoginPress = () => {
    this.props.history.push('/login');
  };

  render() {
    const {
      is_logged_in,
      dank_coin_balance,
      show_tx_in,
      show_tx_out,
    } = this.state;

    let overlay = null;
    if (show_tx_in) {
      overlay = <CryptoInOverlay onDone={this._onTransferInDone} />;
    } else if (show_tx_out) {
      overlay = <CryptoOutOverlay onDone={this._onTransferOutDone} />;
    }

    let balance = null;
    let action = null;
    if (is_logged_in) {
      balance = (
        <View style={styles.balanceWrapper}>
          <Text style={styles.balanceLabel}>Your Balance:</Text>
          <View style={styles.balanceLine}>
            <Image style={styles.icon} resizeMode='contain' source={COIN_IMG} />
            <Text style={styles.coinText}>
              {util.doubleToString(dank_coin_balance)}
            </Text>
          </View>
        </View>
      );
      action = (
        <>
          <WideButton
            style={styles.button}
            text='From Wallet'
            onPress={this._onTransferInPress}
          />
          <WideButton
            style={styles.button}
            text='To Wallet'
            onPress={this._onTransferOutPress}
          />
        </>
      );
    } else {
      balance = (
        <View style={styles.balanceWrapper}>
          <Image style={styles.icon} resizeMode='contain' source={COIN_IMG} />
        </View>
      );
      action = (
        <WideButton
          style={styles.button}
          text='Login'
          onPress={this._onLoginPress}
        />
      );
    }

    return (
      <View style={styles.cryptoScreen}>
        {balance}
        <Text style={styles.text}>
          Dank Coin can be transfered to and from your Ethereum Wallet. Once
          it's in your Crypto Wallet you can trade and pool your coins with
          anyone!
        </Text>
        {action}
        <MenuButton />
        {overlay}
      </View>
    );
  }
}
export default withRouter(CryptoScreen);
